import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";

// The page header (Mercury 03): the title on the left and at most one primary
// action on the right, with anything else behind a More menu beside it. Below
// it sit the section tabs and the chip row of filters and saved views.

interface PageHeaderProps {
  title: ReactNode;
  /** A link back to the list this page belongs to. */
  back?: ReactNode;
  /** A short fact the title does not say, e.g. the version shown. Never the Company. */
  context?: ReactNode;
  /** The one primary action, optionally preceded by a More menu. */
  actions?: ReactNode;
  tabs?: ReactNode;
  /** The chip row: saved view, filters, date. */
  toolbar?: ReactNode;
}
export default function PageHeader({
  title,
  back,
  context,
  actions,
  tabs,
  toolbar
}: PageHeaderProps) {
  return <header {...{
    0: {
      className: "x78zum5 xdt5ytf x5vihii x13q3zuf xh0uz7e"
    },
    1: {
      className: "x78zum5 xdt5ytf x13q3zuf xh0uz7e x5vihii x1qn9uzo"
    }
  }[!!Boolean(tabs) << 0]}>
      <div className="x78zum5 x6s0dn4 x1qughib x1dfszw7 x1ba4aug">
        <div className="x78zum5 xdt5ytf x3d5knr xeuugli">
          {back && <div className="x7x6yu3 x1i6qc9y">{back}</div>}
          <h1 className="x1ghz6dp x1scbmf3 xk50ysn x1lg07ej x1u7k74 xgwkh9f xj0a0fe">{title}</h1>
          {context && <div className="xtu3avg x1i6qc9y">{context}</div>}
        </div>
        {actions && <div className="x78zum5 x2lah0s x6s0dn4 x166cprz">{actions}</div>}
      </div>
      {toolbar && <div className="x1qn9uzo">{toolbar}</div>}
      {tabs}
    </header>;
}